export default __webpack_public_path__ + "static/media/new-logo.2032f004.svg";